import { numero } from "../CadastroRupturaBlocoCeramico/blocoCeramicoCalculos";

export function formatarCodigoBlocoConcreto(codigo, dataRelatorio) {
  const texto = String(codigo ?? "").trim();
  const partes = texto.match(/^(?:RE-BL-)?(\d+)(?:\/(\d{4}))?$/i);
  if (!partes) return texto;
  const ano = partes[2] || String(dataRelatorio || "").match(/^\d{4}/)?.[0] || String(new Date().getFullYear());
  return `RE-BL-${partes[1].padStart(4, "0")}/${ano}`;
}

// ABNT NBR 6136-2:2026, C.8, Tabela C.1. A tabela publicada não lista n = 17.
const PSI = { 6: 0.89, 7: 0.91, 8: 0.93, 9: 0.94, 10: 0.96, 11: 0.97,
  12: 0.98, 13: 0.99, 14: 1, 15: 1.01, 16: 1.02, 18: 1.04 };

export function criarBlocosConcreto(quantidade = 6) {
  return Array.from({ length: quantidade }, (_, index) => ({
    bloco: String(index + 1).padStart(2, "0"), massa: "", comprimentoMedia: "",
    larguraMedia: "", alturaMedia: "", comprimentosIndividuais: ["", "", ""],
    largurasIndividuais: ["", "", ""], alturasIndividuais: ["", "", ""],
    furo1Comprimento: "", furo1Largura: "", furo2Comprimento: "", furo2Largura: "",
    espessurasParedesLongitudinais: ["", "", "", ""],
    espessurasParedesTransversais: ["", "", ""],
    cargaRupturaTf: "",
  }));
}

export function obterMedicoesConcreto(valor) {
  const itens = Array.isArray(valor) ? valor : String(valor ?? "").split(/[;\/|\n]+/);
  return itens.map((item) => String(item ?? "").trim()).filter(Boolean).map(numero).filter(Number.isFinite);
}

function numeroPreenchido(valor) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const convertido = numero(valor);
  return Number.isFinite(convertido) && convertido > 0 ? convertido : "";
}

export function calcularMediaMedicoesConcreto(valor) {
  const medicoes = obterMedicoesConcreto(valor);
  return medicoes.length ? medicoes.reduce((soma, item) => soma + item, 0) / medicoes.length : "";
}

export function calcularBlocosConcreto(blocos = []) {
  return blocos.map((bloco) => {
    const comprimentoCalculado = calcularMediaMedicoesConcreto(bloco.comprimentosIndividuais);
    const larguraCalculada = calcularMediaMedicoesConcreto(bloco.largurasIndividuais);
    const alturaCalculada = calcularMediaMedicoesConcreto(bloco.alturasIndividuais);
    const comprimento = comprimentoCalculado === "" ? numeroPreenchido(bloco.comprimentoMedia) : comprimentoCalculado;
    const largura = larguraCalculada === "" ? numeroPreenchido(bloco.larguraMedia) : larguraCalculada;
    const altura = alturaCalculada === "" ? numeroPreenchido(bloco.alturaMedia) : alturaCalculada;
    const carga = numero(bloco.cargaRupturaTf);
    const area = Number.isFinite(comprimento * largura) && comprimento > 0 && largura > 0 ? comprimento * largura : "";
    // Conversão usada no modelo fornecido: Tf × 1000 × 9,806.
    const forcaRupturaN = Number.isFinite(carga) && carga > 0 ? carga * 9806 : "";
    return { ...bloco, comprimentoMedia: Number.isFinite(comprimento) ? comprimento : "",
      larguraMedia: Number.isFinite(largura) ? largura : "", alturaMedia: Number.isFinite(altura) ? altura : "",
      espessuraParedeLongitudinalMedia: calcularMediaMedicoesConcreto(bloco.espessurasParedesLongitudinais),
      espessuraParedeTransversalMedia: calcularMediaMedicoesConcreto(bloco.espessurasParedesTransversais),
      area, forcaRupturaN,
      tensaoRupturaMpa: area && forcaRupturaN ? forcaRupturaN / area : "" };
  });
}

export function calcularResumoConcreto(blocos = []) {
  const valores = calcularBlocosConcreto(blocos).map((b) => b.tensaoRupturaMpa)
    .filter((valor) => typeof valor === "number" && Number.isFinite(valor));
  const quantidade = valores.length;
  const media = quantidade ? valores.reduce((soma, valor) => soma + valor, 0) / quantidade : "";
  const desvio = quantidade > 1
    ? Math.sqrt(valores.reduce((soma, valor) => soma + (valor - media) ** 2, 0) / (quantidade - 1)) : "";
  const ordenados = [...valores].sort((a, b) => a - b);
  const i = Math.floor(quantidade / 2);
  const psi = PSI[quantidade];
  let motivoFbk = "";
  if (quantidade !== blocos.length) motivoFbk = "Preencha dimensões e carga positivas de todos os blocos para calcular o fbk estimado.";
  else if (quantidade < 6) motivoFbk = "O cálculo do fbk estimado exige pelo menos 6 blocos.";
  else if (psi === undefined) motivoFbk = `A Tabela C.1 não apresenta Ψ para ${quantidade} blocos. O fbk estimado não foi calculado.`;
  const fbkFormula = !motivoFbk ? 2 * ordenados.slice(0, i - 1).reduce((soma, valor) => soma + valor, 0) / (i - 1) - ordenados[i - 1] : "";
  const limite = !motivoFbk ? psi * ordenados[0] : "";
  return { quantidade, media, desvio, coeficiente: desvio !== "" && media > 0 ? desvio / media * 100 : "",
    fbk: !motivoFbk ? Math.max(fbkFormula, limite) : "", fbkFormula, limite, psi, motivoFbk };
}
